import axios, { AxiosInstance, AxiosPromise } from 'axios';
import GerenteAutenticacao from '../gerentes/GerenteAutenticacao';
import router from '@/router';
import storeSistema from '@/store/storeSistema';

const gerenteAutenticacao = new GerenteAutenticacao();
const TokenCrypto = '1AN6N94fxyUgFwrLvEDxWRiCjPWkBRAhT4';
const authHeader = () => ({
  TokenIntegracao: TokenCrypto,
});

export default class ApiPAS {
  protected instance: AxiosInstance;

  protected readonly baseURL: string;

  public constructor() {
    this.baseURL = storeSistema.state.configuracaoApp.urlApiPas;
    this.instance = axios.create({
      baseURL: this.baseURL,
      timeout: 480000,
      headers: {
        TokenIntegracao: TokenCrypto,
        'Content-Type': 'application/json',
      },
    });

    this.interceptaAxios();
  }

  public get(path?: string): AxiosPromise<unknown> {
    return this.instance({
      method: 'GET',
      url: path,
      headers: { ...authHeader() },
    });
  }

  public post(path?: string, data?: unknown): AxiosPromise<unknown> {
    return this.instance({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader() },
    });
  }

  public upload(path?: string, data?: unknown): AxiosPromise<unknown> {
    return this.instance({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
    });
  }

  public patch(path?: string, data?: unknown): AxiosPromise<unknown> {
    return this.instance({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  public delete(path?: string, data?: unknown): AxiosPromise<unknown> {
    return this.instance({
      method: 'DELETE',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  public put(path?: string, data?: unknown): AxiosPromise<unknown> {
    return this.instance({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  public interceptaAxios():void {
    /**
     * axios interceptors runs before and after a request, letting the developer modify req,req more
     * For more details on axios interceptor see https://github.com/axios/axios#interceptors
     */
    this.instance.interceptors.request.use((config) => {
      // do something before executing the request
      // For example tag along the bearer access token to request header or set a cookie
      const requestConfig = config;
      requestConfig.headers.TokenIntegracao = TokenCrypto;

      return requestConfig;
    });

    this.instance.interceptors.response.use(
      (response) => response,
      (error) => {
        /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
        const { response } = error;
        const originalRequest = error.config;

        if (response) {
          if (response.status === 401) {
            gerenteAutenticacao.removerDadosAutenticacao();
            router.push({ name: 'Login' });
          } else if (response.status === 403) {
            router.push({ name: 'SemPermissao' });
          } else if (response.status === 404) {
            router.push({ name: 'PaginaNaoEncontrada' });
          } else if (response.status === 500) {
            router.push({ name: 'ErroRequisicao' });
          } else {
            return originalRequest;
          }
        } else {
          router.push({ name: 'ErroRequisicao' });
        }

        return Promise.reject(error);
      },
    );
  }
}
